import React from "react";
import { FolderOpen, Sparkles, MessageSquare } from "lucide-react";

const TABS = {
  chat: { label: "Chat", Icon: MessageSquare },
  documents: { label: "Documents", Icon: FolderOpen },
  memo: { label: "AI Memo", Icon: Sparkles },
};

// Workspace right panel: tab strip + the active pane. `tabs` controls which tabs exist
// (chat consultations omit "chat" so the conversation is never duplicated).
export function RightPanel({ tabs, active, onChange, badges = {}, children, className = "", panelRef }) {
  return (
    <section ref={panelRef} className={`box-border flex w-full max-w-full min-w-0 flex-col min-h-0 bg-white border border-slate-200 rounded-2xl overflow-hidden ${className}`} data-testid="workspace-right-panel">
      <div className="shrink-0 flex border-b border-slate-100 bg-slate-50/60" role="tablist" data-testid="workspace-tabs">
        {tabs.map((key) => {
          const { label, Icon } = TABS[key];
          const on = active === key;
          return (
            <button
              key={key}
              type="button"
              role="tab"
              aria-selected={on}
              onClick={() => onChange(key)}
              data-testid={`workspace-tab-${key}`}
              className={`relative flex-1 min-w-0 px-3 py-2.5 text-xs font-bold inline-flex items-center justify-center gap-1.5 transition-colors ${on ? "text-[#0A2540] bg-white" : "text-slate-500 hover:text-[#0A2540]"}`}
            >
              <Icon size={13} className="shrink-0" /> <span className="truncate">{label}</span>
              {badges[key] > 0 && (
                <span className="ml-1 min-w-[18px] h-[18px] px-1 rounded-full bg-[#D4AF37] text-[#0A2540] text-[10px] font-extrabold grid place-items-center" data-testid={`workspace-tab-${key}-badge`}>
                  {badges[key] > 99 ? "99+" : badges[key]}
                </span>
              )}
              {on && <span className="absolute inset-x-3 -bottom-px h-0.5 bg-[#D4AF37] rounded-full" />}
            </button>
          );
        })}
      </div>
      <div className="box-border flex w-full max-w-full min-w-0 flex-1 min-h-0 flex-col" data-testid={`workspace-pane-${active}`}>{children}</div>
    </section>
  );
}
